// extracted by mini-css-extract-plugin
export default {"container":"SoftwareTable_container__zCKs0"};